const moduleName = "GiftcardMessage";

export default function GiftcardMessage() {
  const $elements = document.querySelectorAll<HTMLElement>(
    "[module-giftcard-message]:not([data-module-enabled-giftcard-message])"
  );
  $elements.forEach(($element: HTMLElement) => {
    handleEl($element);
  });
}

const handleEl = ($element: HTMLElement) => {
  $element.dataset[`moduleEnabled${moduleName}`] = "";
  const $giftcardBtn = $element.querySelector<HTMLElement>(
    ".giftcard-message__btn"
  );

  if (!$giftcardBtn) {
    return;
  }

  // show giftcard message textarea
  $giftcardBtn.addEventListener("click", () => {
    const $giftcardMessage = $element.querySelector<HTMLElement>(
      ".giftcard-message__textarea-wrapper"
    );
    $giftcardMessage?.classList.add("active");
    $giftcardBtn.classList.add("hidden");
  });

  // update characters count
  const $giftcardTextarea = $element.querySelector<HTMLInputElement>(
    ".giftcard-message__textarea"
  );
  const $charactersCount = $element.querySelector<HTMLElement>(
    ".giftcard-message__count"
  );

  if (!$giftcardTextarea || !$charactersCount) {
    return;
  }

  const maxLength = $giftcardTextarea.getAttribute("maxlength");
  if (!maxLength) {
    return;
  }

  $giftcardTextarea.addEventListener("input", () => {
    const textLength = $giftcardTextarea.value.length;
    $charactersCount.innerText = `${textLength} / ${maxLength}`;
  });

  // submit product form
  const $form = $element.querySelector<HTMLFormElement>("form");

  if (!$form) {
    return;
  }

  // listen to submit event and prevent default

  const displaySuccessMsg = () => {
    const $successMsg = $element.querySelector<HTMLElement>(
      ".giftcard-message__success"
    );
    const $textareaWrapper = $element.querySelector<HTMLElement>(
      ".giftcard-message__textarea-wrapper"
    );

    if (!$successMsg || !$textareaWrapper) {
      return;
    }

    $successMsg?.classList.add("active");
    $textareaWrapper?.classList.remove("active");
    $giftcardTextarea.value = "";
    $charactersCount.innerText = `0 / ${maxLength}`;
    setTimeout(() => {
      $successMsg?.classList.remove("active");
      $giftcardBtn.classList.remove("hidden");
      $textareaWrapper.classList.remove("active");
    }, 3000);
  };

  $form.addEventListener("submit", async (e) => {
    const cart_list_wrapper = document.querySelector(".cart-list");
    cart_list_wrapper?.classList.add("loading");
    e.preventDefault();
    const textarea = $form.querySelector("textarea");
    const formData = new FormData($form);
    const url = $form.action;
    const method = $form.method.toUpperCase();
    const response = await fetch(url, {
      method: method,
      body: formData,
    });

    if (response.status === 200) {
      update_cart(function () {
        var event = document.createEvent("Event");
        event.initEvent("updated_cart", true, true);
        document.dispatchEvent(event);
        cart_list_wrapper?.classList.remove("loading");
      });
      displaySuccessMsg();
    } else {
      throw new Error("Add to cart Error");
    }
  });
};
